<template>
  <header class="header">
    <div class="header__content">
      <div class="header__content__menu">
        <img
          class="header__content__menu__logo"
          src="@/assets/img/logo.jpg"
          alt="Katılım Emeklilik"
          title="Katılım Emeklilik"
          @click="home()"
        />
        <component :is="`Menu${type}`" :data="data"/>
      </div>
      <div class="header__content__profile">
        <!-- <Nautification /> -->
        <component :is="`Profile${type}`" :data="data"/>
      </div>
    </div>
  </header>
</template>

<script>
import MenuIndividual from "./MenuIndividual.vue";
import MenuCorporate from "./MenuCorporate.vue";
import ProfileIndividual from "./ProfileIndividual.vue";
import ProfileCorporate from "./ProfileCorporate.vue";
// import Nautification from './Nautification.vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    MenuIndividual,
    MenuCorporate,
    ProfileCorporate,
    ProfileIndividual,
    // Nautification
  },
  computed: {
    type: function () {
      let type = this.$store.getters.getBankType || "Corporate";

      return type.charAt(0).toUpperCase() + type.slice(1);
    },
    corporateRoute: function () {
      let obj = {
        name: "corporateContractSummary",
      };

      return obj;
    },
    individualRoute: function () {
      let obj = {
        name: "individual",
      };

      return obj;
    },
  },
  methods: {
    home: function () {
      if (
        this.$route.name === "corporateContractSummary" ||
        this.$route.name === "individual"
      )
        return;

      let route =
        this.type === "Corporate" ? this.corporateRoute : this.individualRoute;

      this.$router.push(route);
    },
  },
};
</script>